// src/pages/Catalog/Catalog.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { productsAPI } from '../../api/products.js';
import { categoriesAPI } from '../../api/categories.js';
import { ProductCard } from '../../components/common/ProductCard/ProductCard.jsx';
import { Button } from '../../components/ui/Button/Button.jsx';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs.jsx';
import { Loader } from '../../components/ui/Loader/Loader.jsx';

export const Catalog = () => {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    search: '',
    sort_by: 'createdAt',
    sort_order: 'DESC',
    limit: 20,
  });
  const [total, setTotal] = useState(0);

  useEffect(() => {
    loadData();
  }, [category, filters]);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const [productsRes, categoriesRes] = await Promise.all([
        productsAPI.getAll({ ...filters, category }),
        categoriesAPI.getAll({ is_active: true }),
      ]);
      setProducts(productsRes.data.data || []);
      setTotal(productsRes.data.count || 0);
      setCategories(categoriesRes.data.data || []);
    } catch (error) {
      console.error('Error loading catalog:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSortChange = (e) => {
    const [sort_by, sort_order] = e.target.value.split('-');
    handleFilterChange('sort_by', sort_by);
    handleFilterChange('sort_order', sort_order);
  };

  const breadcrumbs = [
    { label: 'Каталог', path: '/catalog' },
    ...(category ? [{ label: categories.find(c => c.slug === category)?.name || category, path: `/catalog/${category}` }] : []),
  ];

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '24px',
          marginBottom: '32px',
          flexWrap: 'wrap',
          gap: '16px',
        }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: 700,
            color: 'rgb(var(--c-text))',
          }}>
            {category ? categories.find(c => c.slug === category)?.name || 'Категория' : 'Каталог'}
          </h1>

          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <span style={{ fontSize: '14px', color: 'rgb(var(--c-text-secondary))' }}>
              Найдено: {total} товаров
            </span>
            <select
              value={`${filters.sort_by}-${filters.sort_order}`}
              onChange={handleSortChange}
              style={{
                padding: '8px 12px',
                borderRadius: '8px',
                border: '1px solid rgb(var(--c-border))',
                fontSize: '14px',
                backgroundColor: 'rgb(var(--c-surface))',
                color: 'rgb(var(--c-text))',
                outline: 'none',
              }}
            >
              <option value="createdAt-DESC">Сначала новые</option>
              <option value="createdAt-ASC">Сначала старые</option>
              <option value="price-ASC">Сначала дешевле</option>
              <option value="price-DESC">Сначала дороже</option>
              <option value="name-ASC">По имени (А-Я)</option>
              <option value="name-DESC">По имени (Я-А)</option>
            </select>
          </div>
        </div>

        {isLoading ? (
          <Loader text="Загрузка товаров..." />
        ) : products.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 0',
            color: 'rgb(var(--c-text-secondary))',
          }}>
            <p style={{ fontSize: '18px' }}>Товаров не найдено</p>
            <Link to="/catalog">
              <Button style={{ marginTop: '16px' }}>Вернуться в каталог</Button>
            </Link>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '24px',
          }}>
            {products.map((product) => (
              <ProductCard key={product.id} product={product} variant="grid" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};